import { useSelector } from 'react-redux'

import CheckboxListFilter, {
  type CheckboxListFilterProps,
} from '~/components/common/filters/CheckboxListFilter'
import { getInventoryShipmentStatus } from '~/store/reducers/constants'

export interface ShipmentStatusFilterProps extends CheckboxListFilterProps {}

const ShipmentStatusFilter = (props: ShipmentStatusFilterProps) => {
  const InventoryShipmentStatus = useSelector(getInventoryShipmentStatus)

  return <CheckboxListFilter items={InventoryShipmentStatus} {...props} />
}

export default ShipmentStatusFilter
